import { RecommendedComponent } from "./recommended/recommended.component";
import { ItemsComponent } from "./items.component";
import { Routes, RouterModule } from "@angular/router";
import { SignalsComponent } from "./signals/signals.component";
import { ForexComponent } from "./signals/forex.component";
import { TradingComponent } from "./trading/trading.component";
import { MarketingComponent } from "./marketing/marketing.component";
import { EducationComponent } from "./education/education.component";
import { AuthGuard } from "src/app/services/service.index";
import { EventsComponent } from "./events/events.component";
import { OnebetComponent } from "./onebet/onebet.component";
import { SuccessComponent } from "./success/success.component";
import { ServicesItemsComponent } from "./services-items/services-items.component";

const itemsRoutes: Routes = [
  {
    path: "",
    component: ItemsComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "items/signals",
        component: SignalsComponent,
        data: { title: "Índices Sintéticos", filter: "signals" },
      },
      {
        path: "items/forex",
        component: ForexComponent,
        data: { title: "Forex / Futuros", filter: "forex" },
      },
      {
        path: "items/onebet",
        component: OnebetComponent,
        data: { title: "OneBet", filter: "onebet" },
      },
      {
        path: "items/trading",
        component: TradingComponent,
        data: { title: "Curso 0 a 100", filter: "trading" },
      },
      {
        path: "items/pasoapaso",
        component: MarketingComponent,
        data: { title: "Paso a Paso", filter: "marketing" },
      },
      {
        path: "items/academy",
        component: EducationComponent,
        data: { title: "Mentorías", filter: "education" },
      },
      {
        path: "items/event",
        component: EventsComponent,
        data: { title: "Eventos", filter: "event" },
      },
      {
        path: "items/recommended",
        component: RecommendedComponent,
        data: { title: "Recomendados", filter: "recommended" },
      },
      {
        path: "items/services",
        component: ServicesItemsComponent,
        data: { title: "Servicios", filter: "services" },
      },
      {
        path: "items/success",
        component: SuccessComponent,
        data: { title: "Casos de Éxito", filter: "success" },
      },

      { path: "", redirectTo: "/home", pathMatch: "full" },
    ],
  },
];
export const ITEMS_ROUTES = RouterModule.forChild(itemsRoutes);
